'use strict';


var VERTALO = {
    mobileNav: {
        init: function() {
            // mobile nav toggle
            $('[data-toggle]').on('click', function(){
                var $target = $($(this).data('toggle'));
                $target.fadeToggle();
            });

            // submenus
            $('#mobileNav').on('click', '.link--hasChildren .groupLabel', function(event){
                $(this).closest('.link--hasChildren').find('.submenu').toggle();
                $(this).closest('.link--hasChildren').toggleClass('opened');
            });
            $('#mobileNav').on('click', '.link--hasSubmenu .label', function(event){
                event.stopPropagation();
                $(this).closest('.link--hasSubmenu').find('.subsubmenu').toggle();
                $(this).closest('.link--hasSubmenu').toggleClass('opened');
            });
        }
    },
    mainNavSubmenus: {
        init: function() {
            $('.mainNav__links .link--hasChildren .submenu').addClass('transition-all duration-300');
        }
    },
    heroHeading: {
        init: function() {
            $('.section--hero').each(function(){
                var $hero = $(this);
                var words = $hero.find('h1').data('rotating-words');
                words = words.split(',');

                if (words.length > 0) {
                    var i = 0;

                    setInterval(function(){
                        $hero.find('.heading span').fadeOut(function(){
                            var word = words[i=(i+1)%words.length];
                            word = word.replace('::', ' ');

                            $(this).html(word).fadeIn();
                        });
                    }, 2000);
                }
            });
        }
    },
    modals: {
        init: function() {
            $('body').on('click', '[data-modal]', function(event){
                event.preventDefault();

                $($(this).data('modal')).addClass('active');
                $('.blur-wrapper').addClass('blur');
                $('body').css({overflow:'hidden'});
            });

            $('body').on('click', '[data-close-modals]', function(){
                $('body').css({overflow:'auto'});
                $('.blur-wrapper').removeClass('blur');
                $('.modal').removeClass('active');
            });
        }
    },
    expandableBoxes: {
        init: function() {
            $('body').on('click', '[data-expand-box-toggle]', function(event){
                event.preventDefault();

                var $box = $(this);

                $box.toggleClass('expanded');
                $box.find('.expandableText').slideToggle('fast','swing');
            });
        }
    },
    testimonialSlider: {
        init: function() {
            $(".owl-carousel").owlCarousel({
                items: 1,
                autoplay: true,
                autoplayHoverPause: true,
                nav: true,
                rewindNav: true,
                loop: true,
            });
        }
    },
    toggleableContent: {
        init: function() {
            $('body').on('click', '[data-content-toggle]', function(){
                $(this).closest('.toggles').find('[data-content-toggle]').removeClass('active');
                $(this).addClass('active');

                $(this).closest('section').find('[data-toggle-targets] li').hide();
                $($(this).data('content-toggle')).show();
            });
        }
    },
    toggleablePanels: {
        init: function() {
            $('body').on('click', '[data-toggle-target]', function() {
                $('[data-toggle-target]').removeClass('active');
                $(this).addClass('active');

                $(this).closest('section').find('.logos li').removeClass('active');
                $($(this).data('toggle-target')).addClass('active');
            });
        }
    },
    dropdownMenus: {
        init: function() {
            $('body').on('click', '[data-dropdown-menu]', function(){
                $(this).addClass('active');
            });

            $('body').on('click', '[data-dropdown-menu] li', function(event) {
                event.preventDefault();
                event.stopPropagation();

                var $menu = $(this).closest('[data-dropdown-menu]');

                $menu.find('li').removeClass('active');
                $menu.removeClass('active');
                $(this).addClass('active');
            });
        }
    },
    latestNews: {
        init: function() {
            var $latestNews = $('[data-latest-news]');

            if ($latestNews.length) {
                $.ajax({
                   url: '/resources/press',
                   type:'GET',
                   success: function(data){
                       var $news = $(data).find('#latest-news p').slice(0,3);

                       $latestNews.html($news);
                   }
                });
            }
        }
    },
    gate: {
        init: function() {
            $('[data-gate] button').on('click', function(){
                var redirectUrl = '';

                $(this).closest('[data-gate]').find('input[type=checkbox]').each(function(){
                    var $checkbox = $(this);

                    if ($checkbox.is(":checked") && $checkbox.val().length > 0) {
                        redirectUrl = $checkbox.val();
                    }
                });

                if (redirectUrl.length > 0) {
                    window.location.href = redirectUrl;
                }
                else {
                    $('[data-gate]').fadeOut();
                }
            })
        }
    }
}

$(function(){
    VERTALO.mobileNav.init();
    VERTALO.mainNavSubmenus.init();
    VERTALO.heroHeading.init();
    VERTALO.modals.init();
    VERTALO.expandableBoxes.init();
    VERTALO.testimonialSlider.init();
    VERTALO.toggleableContent.init();
    VERTALO.toggleablePanels.init();
    VERTALO.dropdownMenus.init();
    VERTALO.latestNews.init();
    VERTALO.gate.init();
});
